import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NormativaService } from 'app/pages/documenti/normativa/normativa.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'normativa',
  templateUrl: './normativa.component.html',
  styleUrls: ['./normativa.component.scss'],
  providers: [NormativaService]
})
export class NormativaComponent implements OnInit {

  modelList: any[] = [];
  promiseBusy: Promise<any[]>;

  // Base per i PDF (dominio pubblico, non l'API con porta)
  websiteUrl = `${environment.publicSiteBase}/docs/documenti_pdf/`;
  //websiteUrl = 'https://centrofunzionale-coll.regione.campania.it/docs/documenti_pdf/';
  constructor(private restService: NormativaService) { }

  ngOnInit() {
    this.createDocumentiList();
  }

  createDocumentiList() {
    this.restService.selectAll().then(
      res => {
        if (!res || res.length === 0) { 
          this.modelList = [];
          return;
        }
        
        let modelAggregate = {}; 
        
        res.documentiBindList.forEach(item => {
          let tipo = item.idCategoria;
  
          if (!modelAggregate[tipo]) {
            modelAggregate[tipo] = {
              idCategoria: tipo,
              elements: []
            };
          }
  
          modelAggregate[tipo].elements.push({
            url: item.url,
            descrizione: item.descrizione
          });
        });
  
        
        this.modelList = Object.values(modelAggregate);
        
        
      }
    ).catch(error => {
      this.modelList = [];
    });
  }

  openPdfDocument(pdfUrl: string): void {
    const pdfUrlWithParams = `${pdfUrl}#view=FitH&navpanes=0&scrollbar=0`;
    const win = window.open('', '_blank', 'left=20,top=20,width=1000,height=800,resizable=1');
    if (!win) {
      return;
    }
    const escapedUrl = pdfUrlWithParams.replace(/&/g, '&amp;').replace(/\"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const html = `<!DOCTYPE html>
<html lang="it">
<head>
  <meta charset="utf-8" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <title>Documento PDF</title>
  <style>
    html, body { height: 100%; margin: 0; overflow: hidden; }
    .viewer { position: fixed; inset: 0; width: 100vw; height: 100vh; }
  </style>
  </head>
  <body>
    <object class="viewer" data="${escapedUrl}" type="application/pdf" width="100%" height="100%">
      <embed src="${escapedUrl}" type="application/pdf" width="100%" height="100%" />
      <p>Se il PDF non viene visualizzato, <a href="${escapedUrl}" target="_self" rel="noopener">apri il documento</a>.</p>
    </object>
  </body>
</html>`;
    win.document.open();
    win.document.write(html);
    win.document.close();
  }

}
